import { Component } from '@angular/core';
import { CategoriesPage } from '../categories/categories';
import { ClassesPage } from '../classes/classes';
import {GVLogger} from "../../services/gv-logger";


@Component({
  selector: 'page-categories-tabs',
  templateUrl: 'categories-tabs.html',
})
export class CategoriesTabsPage {

  tab1Root = CategoriesPage;
  tab2Root = ClassesPage;

  constructor(private gVLogger: GVLogger) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CategoriesTabsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/categories-tabs/categories-tabs.ts